var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuborder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.58579 0.58579C1.78814e-07 1.17157 0 2.11438 0 4V13C0 14.8856 1.78814e-07 15.8284 0.58579 16.4142C1.17157 17 2.11438 17 4 17H10C11.8856 17 12.8284 17 13.4142 16.4142C14 15.8284 14 14.8856 14 13V4C14 2.11438 14 1.17157 13.4142 0.58579C12.8284 1.78814e-07 11.8856 0 10 0H4C2.11438 0 1.17157 1.78814e-07 0.58579 0.58579ZM4 4C3.44772 4 3 4.44772 3 5C3 5.55228 3.44772 6 4 6H10C10.5523 6 11 5.55228 11 5C11 4.44772 10.5523 4 10 4H4ZM4 8C3.44772 8 3 8.4477 3 9C3 9.5523 3.44772 10 4 10H10C10.5523 10 11 9.5523 11 9C11 8.4477 10.5523 8 10 8H4ZM4 12C3.44772 12 3 12.4477 3 13C3 13.5523 3.44772 14 4 14H8C8.5523 14 9 13.5523 9 13C9 12.4477 8.5523 12 8 12H4Z",
    fill: "#71839B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuborder);
export default __webpack_public_path__ + "static/media/suborder.7b626125a285011cf52706dfec322db7.svg";
export { ForwardRef as ReactComponent };